/* Ergonela Theme – minimales Verhalten: Header-Zustand, Drawer,
   Scroll-Reveal, Galerie, Varianten-Auswahl, AJAX-Warenkorb. */
(function () {
  "use strict";

  const money = (cents) =>
    new Intl.NumberFormat(document.documentElement.lang || "de-DE", {
      style: "currency",
      currency: window.Ergonela?.currency || "EUR",
    }).format(cents / 100);

  /* --- Header: Overlay auf der Startseite, Schatten beim Scrollen --- */
  const header = document.querySelector("[data-header]");
  if (header) {
    const isHome = header.dataset.home === "true";
    const onScroll = () => {
      const scrolled = window.scrollY > 12;
      header.dataset.scrolled = String(scrolled);
      header.dataset.overlay = String(isHome && !scrolled);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* --- Drawer ------------------------------------------------------- */
  function openDrawer(el) {
    if (!el) return;
    el.hidden = false;
    requestAnimationFrame(() => {
      el.dataset.open = "true";
    });
    document.body.style.overflow = "hidden";
    el.querySelector("[data-drawer-close]")?.focus();
  }
  function closeDrawer(el) {
    if (!el) return;
    el.dataset.open = "false";
    document.body.style.overflow = "";
    setTimeout(() => {
      if (el.dataset.open !== "true") el.hidden = true;
    }, 620);
  }
  window.ErgonelaDrawer = { open: openDrawer, close: closeDrawer };

  document.addEventListener("click", (event) => {
    const opener = event.target.closest("[data-drawer-open]");
    if (opener) {
      event.preventDefault();
      openDrawer(document.getElementById(opener.dataset.drawerOpen));
      return;
    }
    const closer = event.target.closest("[data-drawer-close], .drawer__scrim");
    if (closer) {
      event.preventDefault();
      closeDrawer(closer.closest(".drawer"));
    }
  });
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      document.querySelectorAll('.drawer[data-open="true"]').forEach(closeDrawer);
    }
  });

  /* --- Scroll-Reveal ------------------------------------------------ */
  const revealables = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && revealables.length) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.dataset.visible = "true";
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -12% 0px", threshold: 0.12 }
    );
    revealables.forEach((el) => io.observe(el));
  } else {
    revealables.forEach((el) => (el.dataset.visible = "true"));
  }

  /* --- Produktgalerie ----------------------------------------------- */
  document.querySelectorAll("[data-gallery]").forEach((gallery) => {
    const main = gallery.querySelector("[data-gallery-main]");
    gallery.querySelectorAll("[data-gallery-thumb]").forEach((thumb) => {
      thumb.addEventListener("click", () => {
        main.src = thumb.dataset.full;
        main.alt = thumb.dataset.alt || "";
        gallery
          .querySelectorAll("[data-gallery-thumb]")
          .forEach((t) => t.setAttribute("aria-current", String(t === thumb)));
      });
    });
  });

  /* --- Variantenauswahl --------------------------------------------- */
  document.querySelectorAll("[data-product-form]").forEach((form) => {
    const root = form.closest("[data-product]");
    const variants = JSON.parse(root.querySelector("[data-variants]")?.textContent || "[]");
    const idInput = form.querySelector('[name="id"]');
    const priceEl = root.querySelector("[data-price]");
    const compareEl = root.querySelector("[data-compare]");
    const discountEl = root.querySelector("[data-discount]");
    const stockEl = root.querySelector("[data-stock]");
    const submit = form.querySelector('[type="submit"]');
    const selected = [];

    root.querySelectorAll("[data-option-value]").forEach((btn) => {
      const idx = Number(btn.dataset.optionIndex);
      if (btn.getAttribute("aria-pressed") === "true") selected[idx] = btn.dataset.optionValue;
      btn.addEventListener("click", () => {
        root
          .querySelectorAll(`[data-option-index="${idx}"]`)
          .forEach((b) => b.setAttribute("aria-pressed", String(b === btn)));
        selected[idx] = btn.dataset.optionValue;
        update();
      });
    });

    function update() {
      const match = variants.find((v) =>
        v.options.every((opt, i) => (selected[i] == null ? true : selected[i] === opt))
      );
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (compareEl) {
        const hasCompare = match.compare_at_price && match.compare_at_price > match.price;
        compareEl.hidden = !hasCompare;
        if (hasCompare) compareEl.textContent = money(match.compare_at_price);
        if (discountEl) {
          discountEl.hidden = !hasCompare;
          if (hasCompare) {
            discountEl.textContent =
              "Reduziert −" + Math.round((1 - match.price / match.compare_at_price) * 100) + "%";
          }
        }
      }
      if (stockEl) {
        stockEl.classList.toggle("stock--out", !match.available);
        stockEl.querySelector("[data-stock-label]").textContent = match.available
          ? "Auf Lager · sofort versandfertig"
          : "Derzeit nicht verfügbar";
      }
      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available ? "In den Warenkorb" : "Ausverkauft";
      }
      const stickyPrice = root.querySelector("[data-sticky-price]");
      if (stickyPrice) stickyPrice.textContent = money(match.price);
      const stickyBtn = root.querySelector("[data-sticky-atc-button]");
      if (stickyBtn) {
        stickyBtn.disabled = !match.available;
        stickyBtn.textContent = match.available ? "In den Warenkorb" : "Ausverkauft";
      }
      const url = new URL(window.location.href);
      url.searchParams.set("variant", match.id);
      window.history.replaceState({}, "", url);
    }
    update();
  });

  /* --- Sticky Add-to-Cart-Leiste -------------------------------------- */
  document.querySelectorAll("[data-sticky-atc]").forEach((bar) => {
    const root = bar.closest("[data-product]");
    const actions = root?.querySelector(".purchase__actions");
    const form = root?.querySelector("[data-product-form]");
    const btn = bar.querySelector("[data-sticky-atc-button]");
    if (!actions || !form || !btn) return;

    const toggle = (show) => {
      bar.classList.toggle("is-visible", show);
      bar.setAttribute("aria-hidden", String(!show));
      document.body.classList.toggle("has-sticky-atc", show);
    };
    if ("IntersectionObserver" in window) {
      let seen = false;
      new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) seen = true;
          toggle(seen && !entry.isIntersecting && entry.boundingClientRect.top < 0);
        },
        { threshold: 0 }
      ).observe(actions);
    }
    btn.addEventListener("click", () => form.requestSubmit());
  });

  /* --- Mengenwahl ---------------------------------------------------- */
  document.addEventListener("click", (event) => {
    const step = event.target.closest("[data-qty-step]");
    if (!step) return;
    const input = step.parentElement.querySelector("input");
    const next = Math.max(1, Number(input.value || 1) + Number(step.dataset.qtyStep));
    input.value = next;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* --- AJAX-Warenkorb ------------------------------------------------ */
  async function refreshCart(open) {
    const res = await fetch(window.Ergonela.routes.cart + "?section_id=cart-drawer");
    const html = await res.text();
    const fresh = new DOMParser().parseFromString(html, "text/html");
    const nextInner = fresh.querySelector("[data-cart-contents]");
    const current = document.querySelector("[data-cart-contents]");
    if (nextInner && current) current.innerHTML = nextInner.innerHTML;

    const countRes = await fetch(window.Ergonela.routes.cart + ".js");
    const cart = await countRes.json();
    document.querySelectorAll("[data-cart-count]").forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    if (open) openDrawer(document.getElementById("cart-drawer"));
  }
  window.ErgonelaCart = { refresh: refreshCart };

  document.addEventListener("submit", async (event) => {
    const form = event.target.closest("[data-add-to-cart]");
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const label = button?.textContent;
    if (button) {
      button.disabled = true;
      button.textContent = "Wird hinzugefügt…";
    }
    try {
      const res = await fetch(window.Ergonela.routes.cartAdd + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          items: [
            {
              id: Number(form.querySelector('[name="id"]').value),
              quantity: Number(form.querySelector('[name="quantity"]')?.value || 1),
            },
          ],
        }),
      });
      if (!res.ok) throw new Error("cart");
      await refreshCart(true);
    } catch (error) {
      console.error(error);
      form.submit();
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = label;
      }
    }
  });

  document.addEventListener("click", async (event) => {
    const control = event.target.closest("[data-cart-change]");
    if (!control) return;
    event.preventDefault();
    await fetch(window.Ergonela.routes.cartChange + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: control.dataset.lineKey, quantity: Number(control.dataset.cartChange) }),
    });
    await refreshCart(false);
  });
})();
